module.exports = __webpack_public_path__ + "static/media/loading.abd5f9d8.gif";